import { render, staticRenderFns } from "./widget_artificial_intelligence.vue?vue&type=template&id=6384240c&scoped=true&"
import script from "./widget_artificial_intelligence.vue?vue&type=script&lang=js&"
export * from "./widget_artificial_intelligence.vue?vue&type=script&lang=js&"
import style0 from "./widget_artificial_intelligence.vue?vue&type=style&index=0&id=6384240c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384240c",
  null
  
)

export default component.exports